import {
  SET_BUILDER_CITY,
  ADD_SEQUENCES, ADD_SEQUENCES_FAIL, ADD_SEQUENCES_LOADING,
  ADD_BUILDER_ITEM, REMOVE_BUILDER_ITEM,
  ADD_RESERVATION_ITEM, REMOVE_RESERVATION_ITEM,
  CLEAR_BUILDER_LIST
} from '../actions/types';
import update from 'immutability-helper';


const builderInitalState = {
  isFetching:false,
  data:[],
  header:[]
}

export function BuilderSequence(state = builderInitalState, action){
  switch (action.type) {
    case ADD_SEQUENCES_LOADING:
    return update(state, {
      isFetching:{$set:true}
    });
    case ADD_SEQUENCES:
      return update(state, {
        isFetching:{$set:false},
        data:{$set:action.payload.data.data},
        header:{$set:action.payload.data.header}
      });
    case ADD_SEQUENCES_FAIL:
      return state;
    default:
      return state;
  }
}


const builderListInitialState = {
  data:[],
  activeCity:"",
  reservations:[]
}

export function BuilderList(state = builderListInitialState, action){
  switch (action.type) {

    case SET_BUILDER_CITY:
      return update(state, {
        activeCity:{$set:action.payload}
      });

    case ADD_BUILDER_ITEM:

      return update(state, {data:{$push:[action.payload]}  });


    case REMOVE_BUILDER_ITEM:
      return update(state, {
        data:{$splice:[[action.payload, 1]]}
      });

    case ADD_RESERVATION_ITEM:

      return update(state, { reservations:{$push:[action.payload]}});

    case REMOVE_RESERVATION_ITEM:
      return update(state, {
        reservations:{$splice:[[action.payload-1, 1]]}
      });

    case CLEAR_BUILDER_LIST:
      return update(state, {
        activeCity:{$set:""},
        data:{$set:[]},
        reservations:{$set:[]}
      });

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_builder.js